import type { ApiModuleEndpoints } from '../types'

export const saleOnlineApiEndpoints = {
  show: { method: 'GET', path: '/sale-online', requiresAuth: true },
  update: { method: 'PUT', path: '/sale-online', requiresAuth: true },
  stats: { method: 'GET', path: '/sale-online/stats', requiresAuth: true },
  imagePresign: { method: 'POST', path: '/sale-online/image/presign', requiresAuth: true },
  imageConfirm: { method: 'POST', path: '/sale-online/image/confirm', requiresAuth: true },
  imageDelete: { method: 'DELETE', path: '/sale-online/image', requiresAuth: true },
  products: { method: 'GET', path: '/sale-online/products', requiresAuth: true },
  syncProducts: { method: 'PUT', path: '/sale-online/products', requiresAuth: true },
} as const satisfies ApiModuleEndpoints
